import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/src/components/FacebookShare.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/LinkedInShare.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/RichText.module.css");
import(/* webpackMode: "eager" */ "/app/src/components/TwitterShare.tsx")